import React from 'react'
import { ModalConsulta } from '.';
import { Tabela } from '../Basicos';

function ModalConsultaGruposDisponiveis(props) {
    const { estrutura } = props;
    const { grupos } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "Grupos",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Grupo',
                    accessor: 'grupo',
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={grupos}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaGruposDisponiveis;
